const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? window.location.origin 
  : 'http://localhost:3001';

export class LeaderboardService {
  static async getLeaderboard(gameMode) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/leaderboard/${gameMode}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
      throw new Error('Failed to load leaderboard');
    }
  }

  static async submitScore(gameMode, username, score, timeInSeconds) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/leaderboard/${gameMode}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: username.trim(),
          score,
          timeInSeconds
        }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to submit score');
      }
      
      return data;
    } catch (error) {
      console.error('Error submitting score:', error);
      throw error;
    }
  }

  static validateUsername(username) {
    const trimmed = username.trim();
    const regex = /^[a-zA-Z0-9_-]+$/;
    
    if (!trimmed) {
      return { valid: false, error: 'Username cannot be empty' };
    }
    
    if (trimmed.length < 2 || trimmed.length > 20) {
      return { valid: false, error: 'Username must be 2-20 characters long' };
    }
    
    if (!regex.test(trimmed)) {
      return { valid: false, error: 'Username can only contain letters, numbers, hyphens, and underscores' };
    }
    
    return { valid: true };
  }

  static getGameModeKey(gameMode, difficulty) {
    return `${gameMode}-${difficulty}`;
  }

  static getGameModeDisplay(gameModeKey, t) {
    const [mode, diff] = gameModeKey.split('-');
    return `${t(mode + 'Mode')} - ${t(diff)}`;
  }
}